import { getSitesWithNoCoordinates } from '../../utils/verifyMapData';
import { MissingCoordinatesMessage } from './MissingCoordinatesMessage';
import { DefaultMessage } from './DefaultMessage';
import { NewSite } from 'src/types/sites/sites';

export const MapNotification = ({ siteData }: { siteData: NewSite[] | [] }) => {
  if (siteData?.length === 0) {
    return <DefaultMessage />;
  }
  const wrongSiteData: NewSite[] = getSitesWithNoCoordinates(siteData);
  if (wrongSiteData?.length > 0) {
    return <MissingCoordinatesMessage siteData={wrongSiteData} />;
  }

  return <></>;
};
